import { Issue } from '../Issue/styled';

export const PageViewer = Issue;

